export default {
    events: [],
  };
  